import { AutoConf, Result, ResultList, Search } from "core/types/search.types";

export const transformResult = (data: any): Result => ({
  description: data?.description,
  link: data?.link,
  thumbnail: data?.thumbnail,
  title: data?.title,
  signaled: data?.signaled,
  sentiment: data?.sentiment,
});

export const transformSearch = (data: any): Search => ({
  id: data?.id,
  fullName: data?.full_name,
  userId: data?.user_id,
  params: data?.params,
  // results puo' essere assente (es. risposta {message,id} di newSearch) o
  // arrivare a tranche durante la ricerca progressiva: fallback a [] per non rompere.
  results: (data?.results ?? []).map((result: any) => transformResult(result)),
  status: data?.status,
  // Modalita' Social (additiva): pass-through, assenti per le altre modalita'.
  results_by_platform: data?.results_by_platform,
  quota_exceeded_platforms: data?.quota_exceeded_platforms,
});

export const transformResults = (data: any): ResultList[] =>
  data?.map((result: any) => transformResultForList(result));

export const transformResultForList = (data: any): ResultList => ({
  fullName: data?.full_name,
  searchCreationTime: data?.search_creation_time,
  searchId: data?.search_id,
  userId: data?.user_id,
  params: data?.params,
});

export const transformAutoConf = (data: any): AutoConf => ({
  id: data?.id,
  fullName: data?.full_name,
  params: data?.params?.map((p: any) => ({ id: p?.id, name: p?.name })),
});
